import { $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { useCallback } from 'react';
import { Button } from '../../../ui';

type EditorListenerPluginProps = {
  onSubmit?: (markdown: string) => void;
  isDisabled?: boolean;
};

export function EditorListenerPlugin(props: EditorListenerPluginProps) {
  const { onSubmit, isDisabled } = props;
  const [editor] = useLexicalComposerContext();

  const handleClearEditor = useCallback(() => {
    editor.update(() => {
      const root = $getRoot();
      root.clear();
    });

    editor.focus();
  }, [editor]);

  return (
    <Button
      type="submit"
      intent="primary"
      size="small"
      isDisabled={isDisabled}
      {...(onSubmit && {
        onPress: () =>
          editor.getEditorState().read(() => {
            const markdown = $convertToMarkdownString(TRANSFORMERS);
            handleClearEditor();
            onSubmit(markdown);
          }),
      })}
    >
      Toevoegen
    </Button>
  );
}
